import { render, staticRenderFns } from "./Especie.vue?vue&type=template&id=24479063&scoped=true&lang=pug&"
import script from "./Especie.vue?vue&type=script&lang=js&"
export * from "./Especie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24479063",
  null
  
)

export default component.exports